import { NavLink } from 'react-router-dom';
import { useShop } from '../../hooks/useShop';
import { formatMoney, formatDateTime } from '../../utils/formatters';

const NAV = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/statements', label: 'Statements' },
  { to: '/audit-trail', label: 'Activity' },
  { to: '/org', label: 'Org View' },
];

export default function Header({ totalIssues, totalDollars, lastRefresh, onRefresh }) {
  const { shops, currentShopId, currentShop, switchShop } = useShop();
  const shopName = currentShop?.name || currentShop?.shop_name || `Shop #${currentShopId}`;

  return (
    <header className="bg-[#1C1917] border-b border-[#292524]">
      {/* Top bar */}
      <div className="max-w-[1400px] mx-auto px-6 py-3 flex justify-between items-center">
        <div className="flex items-center gap-5">
          <div>
            <div className="text-[10px] text-stone-500 font-bold tracking-[2px] uppercase">
              {shopName}
            </div>
            <div className="text-base font-extrabold text-stone-100 tracking-tight">
              Reconciliation Hub
            </div>
          </div>

          {totalIssues > 0 && (
            <div className="hidden md:flex items-center gap-2 bg-red-950/40 px-3.5 py-1.5 rounded-lg border border-red-900/30">
              <span className="w-2 h-2 rounded-full bg-red-500 pulse-alert" />
              <span className="text-red-400 text-xs font-bold tabular-nums">
                {totalIssues} issues
              </span>
              <span className="text-red-500/50">|</span>
              <span className="text-red-300 text-xs font-extrabold tabular-nums">
                {formatMoney(totalDollars)}
              </span>
            </div>
          )}
        </div>

        <div className="flex items-center gap-2">
          <select
            value={currentShopId || ''}
            onChange={(e) => switchShop(Number(e.target.value))}
            className="bg-[#292524] text-stone-300 text-xs font-semibold px-3 py-2 rounded-lg border border-stone-700 focus:outline-none focus:ring-1 focus:ring-stone-500 appearance-none cursor-pointer"
          >
            {shops.map((s) => (
              <option key={s.id || s.shop_id} value={s.id || s.shop_id}>
                {s.name || s.shop_name}
              </option>
            ))}
          </select>

          <button
            onClick={onRefresh}
            className="bg-[#292524] text-stone-400 px-3 py-2 rounded-lg text-xs font-semibold border border-stone-700 hover:bg-stone-700 transition-colors"
            title="Refresh data"
          >
            &#8635;
          </button>

          {lastRefresh && (
            <div className="text-[10px] text-stone-600 font-mono hidden lg:block">
              {formatDateTime(lastRefresh.toISOString())}
            </div>
          )}
        </div>
      </div>

      {/* Navigation bar */}
      <div className="max-w-[1400px] mx-auto px-6">
        <nav className="flex gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `px-4 py-2.5 text-[13px] font-semibold rounded-t-lg transition-colors ${
                  isActive
                    ? 'bg-[#F3F1EC] text-stone-800'
                    : 'text-stone-500 hover:text-stone-300 hover:bg-stone-800/40'
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
